import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from './listings';

import { GeoWithin } from './filtered-listings/geoWIthin';
import { Sort } from './filtered-listings/sort';

export function SidebarListings(this: ListingsService): Listing[] {
  let output;

  output = this.filteredListings().filter((l) => {
    let included = true;

    if (!this.filteringService.dreamHomes()) {
      included = GeoWithin.call(this, l, included);
    }

    return included;
  });

  // When in search mode, preserve the order established by FilteredListings
  // (related-model open houses first, then exact matches, then remaining related models).
  // if (this.filteringService.ids().length > 0) {
  //   return _output.slice(0, this.chunk());
  // }

  output = output.sort((a, b) => Sort.call(this, a, b));

  return output.slice(0, this.chunk());
}
